import React, { useEffect, useLayoutEffect, useState } from 'react';

import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import { AppStackNavigator } from './src/navigation/appStack';
import { store } from './src/store/store';
import { Provider, useSelector } from 'react-redux';
import Loader from './src/commonComponents/Loader/Loader';
import { useDispatch } from 'react-redux';
import { getConfig, getFAQ } from './src/utils/commonredux/commonRedux.action';
import { ThemeProvider } from './src/theme/ThemeProvider';
import {
  setProfileEmpty,
  setUserProfileAfterLogin,
} from './src/screens/Profile/redux/profile.action';
import { navigationRef } from './src/navigation/rootNavigation';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { headerSet, headerSetPartner } from './src/utils/networkFetch';
import CONFIG from './src/config/config';
import { getUser } from './src/screens/Profile/redux/profile.action';
import { useNetInfo } from '@react-native-community/netinfo';
import NoInternetScreen from './src/commonComponents/NoInternetScreen';
//import CodePush from "react-native-code-push";

import {
  setUpAppsFlyer,
  isMobile,
  setUpSingular,
  isMobileCheck,
  routeMap,
  d24Redirect,
  loadScript,
  atob,
} from './src/utils/commonMethods';
import { useWebSocket } from './src/common/useWebSocket';
import SplashScreen from 'react-native-splash-screen';

import ErrorBoundary from './src/commonComponents/ErrorBoundary';
import DeviceInfo from 'react-native-device-info';
import ForceUpdate from './src/commonComponents/ForceUpdate';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { globalImport } from './src/common/globalImports';
import { globalConfigurableData, globalConst } from './src/utils/globalConstant';
import {
  hideLoader,
  showLoader,
} from './src/commonComponents/Loader/loader.actions';
import {getUserProfile} from './src/screens/Profile/redux/profile.action';
import {connect} from 'react-redux';

import i18n from './src/locale/i18';
import {Platform, Text, View} from 'react-native';
import { setContestVisible } from './src/screens/contest/redux/contest.action';
import { Color } from './src/assets';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ForceCatchEmail from './src/commonComponents/ForceCatcheEmail';
import {magic} from './src/lib/magic';
import { setShowLoginModal, setLoggingIn } from './src/screens/Login/redux/login.action';
import { ToastProvider } from './src/components/core/Toast';


    
    

  


const config = {
  screens: {
    contestDetail: {
      path: '/:contestId',
    },
    ContestEvents: {
      path: '/:contestId/:eventId/:isMulti',
    },
    WalletSuccess: 'WalletSuccess',
  },
};
const linking = {
  prefixes: [
    /* your linking prefixes */
  ],
  config,
};

if (!globalImport.isWeb) {
  var CodePushOptions = {
    //checkFrequency: CodePush.CheckFrequency.ON_APP_RESUME,
    installMode: CodePush.InstallMode.ON_NEXT_RESTART,
    updateCheckFrequency: CodePush.CheckFrequency.ON_APP_START,
    rollbackRetryOptions: {
      delayInHours: 1,
      maxRetryAttempts: 5,
    },
  };
}

const mapDispatchToProps = {
  getUserProfile,
  setShowLoginModal,
  setLoggingIn
};

const App = connect(null, mapDispatchToProps)(({getUserProfile, setShowLoginModal, setLoggingIn}) => {

  useEffect(() => {
    handleRedirectFlowMagicLink()
    
  }, []);

  const handleRedirectFlowMagicLink = async () => {
    if (localStorage.getItem('isOauthRedirect')) {
      setShowLoginModal(true, {});
      setLoggingIn(true);
      await handleRedirect();
      checkUser();      
      localStorage.removeItem('isOauthRedirect');
    } else {
      // getMetadata();
    }
  }

  const handleRedirect = async () => {
    try {
      const result = await magic.oauth2.getRedirectResult();
      if (result) {
        console.log('Login successful:', result);
        const userData = await magic.user.getMetadata();        
        const p = { getUserProfile };
        // debugger;
        
        const res = await getUserProfile(null, null, null, null, null, null, {
          userMetadata: result?.magic?.userMetadata,
          idToken: result?.magic?.idToken, 
          magicToken: result.oauth.accessToken
        });
        if(!res?.data?.first_time_login && res?.data?.ageconsent) {
          setShowLoginModal(false, {});  
        }
        setLoggingIn(false);
        return;
      }
    } catch (error) {
      console.error('Error handling redirect:', error);
      return;
    }
  };

  const checkUser = async () => {
    try {
      const isLoggedIn = await magic.user.isLoggedIn();
      if (isLoggedIn) {
        const userData = await magic.user.getMetadata();
        
      }
    } catch (error) {
      console.error('Error checking user:', error);
    } finally {
      
    }
  };
  
  if (globalImport.isWeb) {
    const [fontsLoaded] = globalImport?.ExpoFonts?.useFonts({
      'Inter': require('./src/assets/fonts/Inter.woff2')
      // 'NeueHaasDisplay-Mediu': require('./src/assets/fonts/NeueHaasDisplay-Mediu.ttf'),
      // 'NeueHaasDisplay-Roman': require('./src/assets/fonts/NeueHaasDisplay-Roman.ttf'),
      // 'NeueHaasDisplay-RomanItalic': require('./src/assets/fonts/NeueHaasDisplay-RomanItalic.ttf'),
    });
  }

  const dispatch = useDispatch();
  const isAppLogin = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const isMaintanence = useSelector(
    ({ utilReducer }) => utilReducer.globalConfigData?.appEnabled,
  );
  const [mobileEmailSheet, setMobileEmailSheet] = useState(null);

  const netInfo = useNetInfo();
  useWebSocket(isAppLogin);


  useEffect(() => {
    try {
      if (globalImport.isWeb) {
        window.clevertap.spa = true;
        window.clevertap.privacy.push({ useIP: true });
      }
    } catch (e) { }

    if (isMobile()) {
      //document.body.style.maxWidth = "1200px";
      // document.body.style.paddingRight = "100px";
      //document.body.style.margin = "auto";
      //document.body.style.backgroundColor = "white";
    }
    if (globalConfigurableData.isMobileViewInDesktop && !isMobileCheck()) {
      document.body.style.width = '420px';
      document.body.style.margin = 'auto';
      document.body.style.backgroundColor = 'darkGrey';
    }

    setTimeout(() => {
      Boolean(SplashScreen) && SplashScreen.hide();
    }, 500);
  }, []);

  React.useLayoutEffect(() => {
    checkLogin();
    //CleverTap.setDebugLevel(3);
    // setUpSingular();
    if (!globalImport.isWeb) {
      globalImport.CleverTap.createNotificationChannel(
        'TradexNC',
        'TradeX Notification channel',
        'TradeX Notification channel',
        5,
        true,
      );
    }

    // CleverTap.addListener(CleverTap.CleverTapPushNotificationClicked, (e)=>{
    //   alert(e);
    //   console.log("CLevertap listener");
    // });
  }, []);

  async function checkLogin() {
    let token;
    let lang;
    let partner;
    if (globalImport.isWeb) {
      document.body.style.backgroundColor =
        globalConfigurableData.globalThemeColor;
      token = window.localStorage.getItem('token');
      lang = window.localStorage.getItem('lang');
      partner = window.localStorage.getItem('partner');
    } else {
      token = await AsyncStorage.getItem('token');
      lang = await AsyncStorage.getItem('lang');
    }
    if (!token) {
      headerSet(CONFIG.LOG_OUT_TOKEN);
    } else {
      headerSet(token);
      if (globalConst.partnerId !== 1) {
        headerSetPartner(partner ? partner : 1);
      }
      dispatch(setUserProfileAfterLogin());
    }
    //dispatch(showLoader());
    await dispatch(getUser());
    //dispatch(hideLoader());
    dispatch(getConfig());
    dispatch(getFAQ());
    let isContestVisible;
    if (globalImport.isWeb) {
      isContestVisible = localStorage.getItem('isContestVisible');
    } else {
      isContestVisible = await AsyncStorage.getItem('isContestVisible');
    }
    if (isContestVisible) {
      dispatch(setContestVisible(true));
    }
    if (token) {
      let userInfo = store.getState()?.profile?.profileData;
      if (userInfo?.showVerifyEmailPopUp) {
        setMobileEmailSheet('email');
      }
      if (lang) {
        await i18n.changeLanguage(lang);
      } else {
        if (userInfo?.preferred_locale) {
          if (globalImport.isWeb) {
            window.localStorage.setItem('lang', userInfo?.preferred_locale);
          } else {
            await AsyncStorage.setItem('lang', userInfo?.preferred_locale);
          }
          await i18n.changeLanguage(userInfo?.preferred_locale);
        }
      }
      // if (userInfo?.is_chatbot_enabled) loadScript();
    }
  }

  return netInfo.type === 'unknown' ||
    netInfo.type === 'undefined' ||
    netInfo.isConnected ? (
    <ToastProvider>
      <ForceCatchEmail
        setMobileEmailSheet={setMobileEmailSheet}
        mobileEmailSheet={mobileEmailSheet}
      />
      <AppStackNavigator
        token={globalImport.isWeb ? localStorage.getItem('token') : isAppLogin}
        isMaintanence={isMaintanence}
      />
    </ToastProvider>
  ) : (
    <NoInternetScreen />
  );
});

const AppWrappedWithStore = () => {
  const [isReady, setIsReady] = React.useState(
    globalImport.isWeb ? false : true,
  );

  const [initialState, setInitialState] = React.useState();

  const returnSID = () => {
    var query = window.location.search.substring(1);
    // if (query?.split("?").length > 1) {
    //   var splitArr = query?.split("?");
    //   query = splitArr[splitArr.length - 1];
    // }
    // const params = new URLSearchParams(window.location.href);
    const sId = query.split('=')[1];
    return sId;
  };

  const deduceRoutes = () => {
    var savedStateString;
    const urlHref = window.location.href;
    try {
      if (urlHref.includes('session_id')) {
        savedStateString = JSON.parse(routeMap?.otpless);
        var sId = returnSID();
        savedStateString.routes[2].params.sId = sId;
      } else if (
        urlHref.includes('Login') &&
        !urlHref.includes('isFirstLogin')
      ) {
        if (urlHref.includes("coupon")) {
          savedStateString = JSON.parse(routeMap?.loginCoupon);
          var query = window.location.search.substring(1);
          const params = new URLSearchParams(query);
          var coupon = params.get('coupon');
          savedStateString.routes[1].params.coupon = coupon;
        }
        else {
          savedStateString = JSON.parse(routeMap?.login);
        }
      } else if (urlHref.includes('eventId')) {
        savedStateString = JSON.parse(routeMap?.eventId);
        var query = window.location.search.substring(1);
        const params = new URLSearchParams(query);
        var eventId = params.get('eventId');
        var isMulti = params.get('isMulti');
        savedStateString.routes[1].params.eventId = eventId;
        savedStateString.routes[1].params.isMulti = isMulti !== 'false';
      } else if (urlHref.includes('referCode')) {
        localStorage.setItem('promoCode', returnSID());
      } else if (urlHref.includes('WalletAdd')) {
        savedStateString = JSON.parse(routeMap?.walletAdd);
      } else if (urlHref.includes('WalletWithdraw')) {
        savedStateString = JSON.parse(routeMap?.walletWithdraw);
      } else if (urlHref.includes('Wallet')) {
        savedStateString = JSON.parse(routeMap?.wallet);
      } else if (urlHref.includes('Contest')) {
        savedStateString = JSON.parse(routeMap?.rewards);
      } else if (urlHref.includes('Portfolio')) {
        savedStateString = JSON.parse(routeMap?.portfolio);
      } else if (urlHref.includes('WalletSuccess?status=success')) {
        savedStateString = JSON.parse(d24Redirect('success'));
      } else if (urlHref.includes('WalletSuccess?status=cancel')) {
        savedStateString = JSON.parse(d24Redirect('cancel'));
      } else if (urlHref.includes('WalletSuccess?status=failure')) {
        savedStateString = JSON.parse(d24Redirect('failure'));
      } else if (urlHref.includes('d24')) {
        savedStateString = JSON.parse(routeMap?.d24);
        savedStateString.routes[2].params.rechargeDetails = JSON.parse(
          atob(window.location.href.split('=')[1]),
        );
      } else if (urlHref.includes('hashtag')) {
        savedStateString = JSON.parse(routeMap?.hashtag);
        let hashTag = window.location.href.split('=')[1].split('&')[0];
        // if (!hashTag.includes('#')) {
        //   hashTag = '#' + hashTag;
        // }
        savedStateString.routes[1].params.hash_tag = atob(hashTag);
      } else {
        let savedState = window?.sessionStorage.getItem('ROUTE_PERSIST');
        savedStateString = savedState ? JSON.parse(savedState) : undefined;
      }
    } catch (e) { }

    return savedStateString;
  };

  React.useEffect(() => {
    const restoreState = async () => {
      try {
        //const initialUrl = await Linking.getInitialURL();

        if (globalImport.isWeb) {
          let state = undefined;

          var routeState = deduceRoutes();
          state = routeState ? routeState : state;

          if (state !== undefined) {
            setInitialState(state);
          }
        }
      } finally {
        setIsReady(true);
      }
    };

    if (!isReady) {
      restoreState();
    }
  }, [isReady]);

  useEffect(() => {
    globalConfigurableData?.initFunction();
  }, []);

  if (!isReady) {
    return null;
  }
  const MyTheme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      background: '',
    },
  };
  // if(!magic) return (
  //   <View>
  //     <Text>Loading...</Text>
  //   </View>    
  // )
  return (
    <Provider store={store}>
      <ThemeProvider>
        <SafeAreaProvider>
          <ErrorBoundary>
            <ForceUpdate>
              <ToastProvider>
                <NavigationContainer
                  initialState={initialState}
                  linking={linking}
                  documentTitle={{
                    formatter: (options, route) => globalConfigurableData.appName,
                  }}
                  ref={navigationRef}
                  theme={MyTheme}
                  onStateChange={state => {
                    if (globalImport.isWeb) {
                      window?.sessionStorage.setItem(
                        'ROUTE_PERSIST',
                        JSON.stringify(state),
                      );
                      try {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: 'instant',
                        });
                      } catch (err) {
                        if (window.scrollTo) {
                          window.scrollTo(0, 0);
                        }
                      }
                    }
                  }}>
                  <GoogleOAuthProvider clientId={globalConst?.googleClientId}>
                    <App />
                  </GoogleOAuthProvider>
                </NavigationContainer>
                <Loader />
              </ToastProvider>
            </ForceUpdate>
          </ErrorBoundary>
        </SafeAreaProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default globalImport.CodePush(CodePushOptions)(AppWrappedWithStore);
